// @ts-check

/**
 * The render pass for a command.
 *
 * @enum {number}
 * @private
 */
const Pass = {
  // If you add/modify/remove Pass constants, also change the automatic GLSL constants
  // that start with 'czm_pass'
  //
  // Commands are executed in order by pass up to the translucent pass.
  // Translucent geometry needs special handling (sorting/OIT). The compute pass
  // is executed first and the overlay pass is executed last. Both are not sorted
  // by frustum.
  ENVIRONMENT: 0,
  COMPUTE: 1,
  GLOBE: 2,
  TERRAIN_CLASSIFICATION: 3,
  CESIUM_3D_TILE_EDGES: 4,
  CESIUM_3D_TILE_PLANAR_FILL_ID: 5,
  CESIUM_3D_TILE: 6,
  CESIUM_3D_TILE_CLASSIFICATION: 7,
  CESIUM_3D_TILE_CLASSIFICATION_IGNORE_SHOW: 8,
  OPAQUE: 9,
  TRANSLUCENT: 10,
  VOXELS: 11,
  GAUSSIAN_SPLATS: 12,
  CESIUM_3D_TILE_EDGES_DIRECT: 13,
  OVERLAY: 14,
  NUMBER_OF_PASSES: 15,
};

Object.freeze(Pass);

export default Pass;
